
import React from 'react'
import PropTypes from 'prop-types'
import { Trans } from 'react-i18next'
import { withTranslationCustom } from 'lib/i18next'
import { logException } from 'lib/errors'
import Link from 'components/Link'

/**
 * Try to translate appError based on errors.json translations messages (by app error type and code).
 */
const TranslatedAppError = ({ t, appError, children }) => {
    try {
        if (!appError || !appError.type || !appError.code) {
            return children
        }

        const type = appError.type
        const code = appError.code

        let error

        try {
            error = t(`errors:${type}`, { returnObjects: true })[`${code}`]
        } catch (e) {
            logException('Invalid error type or invalid error translation files - appError:', { ...appError })
            return children
        }

        if (!error || !error.message) {
            return children
        }

        const errorMessage = error.message

        const mapErrorLinks = (message) => message.links && (
            message.links.map((link, i) => (
                <Link
                    key={i}
                    to={link.url}
                    trackName="error"
                >
                    link
                </Link>
            ))
        )

        const translatedErrorMessage = (message, index = 0) => {
            return message.message ? (
                <p key={index}>
                    <Trans components={mapErrorLinks(message)}>
                        {message.message}
                    </Trans>
                </p>
            ) : false
        }

        // there can be multiple error messages in one error, so check if we have array of messages
        const messages = Array.isArray(errorMessage) ? (
            errorMessage.map((message, i) => {
                return translatedErrorMessage(message, i)
            })
        ) : (
            [translatedErrorMessage({ message: errorMessage })]
        )

        // return default (children) message if any of the error messages failed to properly translate
        // due to errors in translation file
        return messages.includes(false) ? children : messages
    } catch (e) {
        logException(e)
        return children
    }
}

export default withTranslationCustom(['errors'])(TranslatedAppError)

TranslatedAppError.propTypes = {
    children: PropTypes.node.isRequired,
    appError: PropTypes.object.isRequired,
}
